import { Box } from "@mui/material"
import { useState } from "react"
import CallLogList from "./sub_components/CallLogList"
import CallLogVisualizerDrawer from "./sub_components/CallLogVisualizerDrawer"

export default function CallLogsPage() {
  const [selectedCallSid, setSelectedCallSid] = useState<string | null>(null)

  const handleSelectCall = (callSid: string) => {
    setSelectedCallSid(callSid)
  }

  const handleCloseVisualizer = () => {
    setSelectedCallSid(null)
  }

  return (
    <Box sx={{ display: "flex", height: "100vh", overflow: "hidden" }}>
      <Box
        sx={{
          flex: 1,
          overflow: "hidden",
          display: "flex",
          flexDirection: "column"
        }}
      >
        <CallLogList onSelectCall={handleSelectCall} />
      </Box>

      <CallLogVisualizerDrawer
        open={!!selectedCallSid}
        onClose={handleCloseVisualizer}
        callSid={selectedCallSid}
      />
    </Box>
  )
}
